function setupSwitcher() {
  var root = document.querySelector('[data-ad-switch]');
  if (!root) return;
  var pill = root.querySelector('.ad-switch__pill');
  var panel = root.querySelector('.ad-switch__panel');
  if (!pill || !panel) return;

  function setOpen(open) {
    panel.hidden = !open;
    pill.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  pill.addEventListener('click', function () {
    setOpen(panel.hidden);
  });

  document.addEventListener('click', function (event) {
    if (!root.contains(event.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  var toggle = root.querySelector('[data-ad-grain-toggle]');
  var fields = root.querySelector('[data-ad-grain-fields]');
  var amounts = root.querySelector('[data-ad-grain-amount]');
  var blends = root.querySelector('[data-ad-grain-blend]');
  var copy = root.querySelector('[data-ad-grain-copy]');
  var color = root.querySelector('[data-ad-grain-color]');
  if (!toggle || !fields || !amounts || !blends || !copy) return;
  var presets = window.adGrainPresets || {};
  var base = presets.film || { size: 96, density: 16, opacity: 13, shade: 'film', blend: 'soft-light' };
  var presetButtons = amounts.querySelectorAll('[data-amount]');
  var shadeButtons = root.querySelectorAll('[data-shade]');
  var blendButtons = blends.querySelectorAll('[data-blend]');
  var inputs = root.querySelectorAll('[data-ad-grain-input]');
  var knownShades = {};
  shadeButtons.forEach(function (button) { knownShades[button.getAttribute('data-shade')] = true; });

  function storedProps() {
    var raw = document.documentElement.getAttribute('data-grain-props');
    if (!raw) {
      try { raw = localStorage.getItem('ad-grain-props'); } catch (error) {}
    }
    if (raw) {
      try { return Object.assign({}, base, JSON.parse(raw)); } catch (error) {}
    }
    var preset = document.documentElement.getAttribute('data-grain-preset');
    if (preset && presets[preset]) return Object.assign({}, presets[preset]);
    return Object.assign({}, base);
  }

  function readInputs() {
    var props = Object.assign({}, base);
    inputs.forEach(function (input) {
      props[input.getAttribute('data-ad-grain-input')] = Number(input.value);
    });
    var shade = 'film';
    shadeButtons.forEach(function (button) {
      if (button.getAttribute('aria-pressed') === 'true') shade = button.getAttribute('data-shade');
    });
    if (color && color.closest('.ad-switch__shade').classList.contains('is-selected')) shade = color.value;
    props.shade = shade;
    blendButtons.forEach(function (button) {
      if (button.getAttribute('aria-pressed') === 'true') props.blend = button.getAttribute('data-blend');
    });
    return props;
  }

  function same(props, preset) {
    return props.size === preset.size && props.density === preset.density && props.opacity === preset.opacity && props.shade === preset.shade && props.blend === preset.blend;
  }

  function paint(props) {
    var on = document.documentElement.getAttribute('data-grain') !== 'off';
    toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
    fields.hidden = !on;
    inputs.forEach(function (input) {
      var key = input.getAttribute('data-ad-grain-input');
      input.value = props[key];
      var readout = root.querySelector('[data-ad-grain-readout="' + key + '"]');
      if (readout) readout.textContent = props[key];
    });
    var custom = !knownShades[props.shade];
    shadeButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-shade') === props.shade ? 'true' : 'false');
    });
    if (color) {
      if (custom) color.value = props.shade;
      color.closest('.ad-switch__shade').classList.toggle('is-selected', custom);
    }
    blendButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-blend') === props.blend ? 'true' : 'false');
    });
    presetButtons.forEach(function (button) {
      var preset = presets[button.getAttribute('data-amount')];
      button.setAttribute('aria-pressed', preset && same(props, preset) ? 'true' : 'false');
    });
  }

  function commit(props) {
    var json = JSON.stringify(props);
    document.documentElement.setAttribute('data-grain-props', json);
    document.documentElement.removeAttribute('data-grain-preset');
    try { localStorage.setItem('ad-grain-props', json); } catch (error) {}
    if (document.documentElement.getAttribute('data-grain') !== 'off' && window.adApplyGrain) {
      window.adApplyGrain(props);
    }
    paint(props);
  }

  function setOn(on) {
    document.documentElement.setAttribute('data-grain', on ? 'on' : 'off');
    try { localStorage.setItem('ad-grain', on ? 'on' : 'off'); } catch (error) {}
    if (on && window.adApplyGrain) window.adApplyGrain(readInputs());
    if (!on && document.body) document.body.style.removeProperty('--ad-grain');
    paint(readInputs());
  }

  toggle.addEventListener('click', function () {
    setOn(document.documentElement.getAttribute('data-grain') === 'off');
  });

  presetButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var preset = presets[button.getAttribute('data-amount')];
      if (preset) commit(Object.assign({}, preset));
    });
  });

  inputs.forEach(function (input) {
    input.addEventListener('input', function () {
      commit(readInputs());
    });
  });

  shadeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      shadeButtons.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
      if (color) color.closest('.ad-switch__shade').classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'true');
      commit(readInputs());
    });
  });

  if (color) {
    color.addEventListener('input', function () {
      shadeButtons.forEach(function (button) { button.setAttribute('aria-pressed', 'false'); });
      color.closest('.ad-switch__shade').classList.add('is-selected');
      commit(readInputs());
    });
  }

  blendButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      blendButtons.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
      button.setAttribute('aria-pressed', 'true');
      commit(readInputs());
    });
  });

  copy.addEventListener('click', function () {
    var props = readInputs();
    var on = document.documentElement.getAttribute('data-grain') !== 'off';
    var text = [
      'grain: ' + (on ? 'on' : 'off'),
      'size: ' + props.size,
      'density: ' + props.density,
      'opacity: ' + props.opacity,
      'shade: ' + props.shade,
      'blend: ' + props.blend
    ].join('\n');
    function done() {
      copy.textContent = 'Copied';
      window.setTimeout(function () { copy.textContent = 'Copy properties'; }, 1400);
    }
    function fallback() {
      var area = document.createElement('textarea');
      area.value = text;
      document.body.appendChild(area);
      area.select();
      try { document.execCommand('copy'); } catch (error) {}
      area.remove();
      done();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(fallback);
      return;
    }
    fallback();
  });

  paint(storedProps());
}

var DRAWER_SECTION = 'antidumb-cart-drawer';

function setupDrawer() {
  var dialog = document.querySelector('[data-ad-drawer]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var status = dialog.querySelector('[data-ad-drawer-status]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cartUrl = dialog.getAttribute('data-cart-url') || '/cart';
  var changeUrl = (dialog.getAttribute('data-change-url') || '/cart/change') + '.js';
  var updateUrl = (dialog.getAttribute('data-update-url') || '/cart/update') + '.js';
  var lastFocus = null;
  var controller = null;
  var noteTimer = null;
  var closeTimer = null;

  function wrapper() {
    return document.getElementById('shopify-section-' + DRAWER_SECTION);
  }

  function announce(message) {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () { status.textContent = message; }, 60);
  }

  function syncCount() {
    var inner = dialog.querySelector('[data-ad-drawer-inner]');
    var count = inner ? inner.getAttribute('data-count') : null;
    if (count === null) return;
    document.querySelectorAll('[data-ad-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
    document.dispatchEvent(new CustomEvent('ad:cart-count', { detail: { count: Number(count) } }));
  }

  function render(sections) {
    var html = sections && sections[DRAWER_SECTION];
    var live = wrapper();
    if (!html || !live) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + DRAWER_SECTION);
    var hadFocus = live.contains(document.activeElement);
    var focused = hadFocus ? document.activeElement.getAttribute('aria-label') : null;
    var note = live.querySelector('[data-ad-note]');
    var noteValue = note ? note.value : null;
    var openTab = live.querySelector('[data-ad-tab][aria-expanded="true"]');
    var openPanel = openTab ? openTab.getAttribute('aria-controls') : null;
    live.innerHTML = fresh ? fresh.innerHTML : html;
    if (noteValue !== null) {
      var freshNote = live.querySelector('[data-ad-note]');
      if (freshNote) freshNote.value = noteValue;
    }
    if (openPanel) {
      var freshTab = live.querySelector('[data-ad-tab][aria-controls="' + openPanel + '"]');
      var freshPanel = document.getElementById(openPanel);
      if (freshTab && freshPanel) {
        freshTab.setAttribute('aria-expanded', 'true');
        freshPanel.hidden = false;
      }
    }
    if (hadFocus && dialog.open) {
      var target = (focused && Array.from(live.querySelectorAll('[aria-label]')).find(function (el) {
        return el.getAttribute('aria-label') === focused;
      })) || dialog.querySelector('[data-ad-drawer-close]');
      if (target) target.focus();
    }
    syncCount();
  }

  function open(trigger) {
    window.clearTimeout(closeTimer);
    if (dialog.open) {
      dialog.classList.add('is-open');
      return;
    }
    lastFocus = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('ad-drawer-lock');
    void dialog.offsetWidth;
    dialog.classList.add('is-open');
    var close = dialog.querySelector('[data-ad-drawer-close]');
    if (close) close.focus();
    document.dispatchEvent(new CustomEvent('ad:drawer', { detail: { open: true } }));
  }

  function close() {
    if (!dialog.open) return;
    dialog.classList.remove('is-open');
    closeTimer = window.setTimeout(function () { dialog.close(); }, reduced.matches ? 0 : 300);
  }

  dialog.addEventListener('close', function () {
    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('ad-drawer-lock');
    flushNote();
    var restore = lastFocus && lastFocus !== document.body && document.contains(lastFocus)
      ? lastFocus
      : document.querySelector('[data-ad-cart-open]');
    if (restore) restore.focus();
    document.dispatchEvent(new CustomEvent('ad:drawer', { detail: { open: false } }));
  });

  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    close();
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) {
      close();
      return;
    }
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('[data-ad-drawer-close]')) {
      close();
      return;
    }
    var tab = target.closest('[data-ad-tab]');
    if (tab) {
      var expanded = tab.getAttribute('aria-expanded') === 'true';
      dialog.querySelectorAll('[data-ad-tab]').forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
      if (!expanded) {
        tab.setAttribute('aria-expanded', 'true');
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = false;
          var field = panel.querySelector('textarea, input');
          if (field) field.focus();
        }
      }
      return;
    }
    if (target.closest('[data-ad-discount-apply]')) {
      applyDiscount();
      return;
    }
    var removeCode = target.closest('[data-ad-discount-remove]');
    if (removeCode) {
      var drop = removeCode.getAttribute('data-ad-discount-remove');
      updateDiscounts(currentCodes().filter(function (code) { return code !== drop; }), null);
      return;
    }
    var line = target.closest('[data-ad-line]');
    if (line) {
      event.preventDefault();
      changeLine(line.getAttribute('data-key'), Number(line.getAttribute('data-qty')));
    }
  });

  async function post(url, body) {
    if (controller) controller.abort();
    controller = new AbortController();
    var isForm = body instanceof FormData;
    if (isForm) {
      body.append('sections', DRAWER_SECTION);
      body.append('sections_url', window.location.pathname);
    } else {
      body.sections = DRAWER_SECTION;
      body.sections_url = window.location.pathname;
    }
    var response;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: isForm ? body : JSON.stringify(body),
        signal: controller.signal
      });
    } catch (error) {
      if (error.name !== 'AbortError') error.network = true;
      throw error;
    }
    var data = await response.json();
    if (!response.ok || data.status) {
      var error = new Error(data.description || data.message || 'Cart error');
      error.cart = true;
      throw error;
    }
    return data;
  }

  async function changeLine(key, quantity) {
    if (!key) return;
    dialog.classList.add('is-busy');
    try {
      var data = await post(changeUrl, { id: key, quantity: Math.max(0, quantity) });
      render(data.sections);
      announce(quantity > 0 ? 'Cart updated.' : 'Removed from cart.');
    } catch (error) {
      if (error.name === 'AbortError') return;
      announce(error.cart ? error.message : 'Could not update the cart. Try again.');
    } finally {
      dialog.classList.remove('is-busy');
    }
  }

  function currentCodes() {
    var box = dialog.querySelector('[data-ad-discount]');
    var codes = box ? box.getAttribute('data-codes') || '' : '';
    return codes.split(',').filter(Boolean);
  }

  function applyDiscount() {
    var field = dialog.querySelector('[data-ad-discount-field]');
    if (!field) return;
    var code = field.value.trim();
    if (!code) {
      field.focus();
      return;
    }
    var codes = currentCodes().filter(function (existing) {
      return existing.toLowerCase() !== code.toLowerCase();
    });
    codes.push(code);
    updateDiscounts(codes, code);
  }

  async function updateDiscounts(codes, added) {
    dialog.classList.add('is-busy');
    try {
      var data = await post(updateUrl, { discount: codes.join(',') });
      render(data.sections);
      var field = dialog.querySelector('[data-ad-discount-field]');
      if (field) field.focus();
      if (!added) {
        announce('Discount removed.');
        return;
      }
      var match = (data.discount_codes || []).find(function (entry) {
        return entry.code.toLowerCase() === added.toLowerCase();
      });
      var valid = Boolean(match && match.applicable);
      var message = valid ? 'Discount applied.' : 'That code is not valid for this cart.';
      var note = dialog.querySelector('[data-ad-discount-msg]');
      if (note && !valid) {
        note.textContent = message;
        note.hidden = false;
        if (field) {
          field.value = added;
          field.setAttribute('aria-invalid', 'true');
          field.setAttribute('aria-describedby', 'ad-drawer-discount-msg');
        }
      }
      announce(message);
    } catch (error) {
      if (error.name === 'AbortError') return;
      announce(error.cart ? error.message : 'Could not update the discount. Try again.');
    } finally {
      dialog.classList.remove('is-busy');
    }
  }

  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !(event.target instanceof HTMLInputElement)) return;
    if (!event.target.hasAttribute('data-ad-discount-field')) return;
    event.preventDefault();
    applyDiscount();
  });

  function flushNote() {
    var field = dialog.querySelector('[data-ad-note]');
    if (!field || noteTimer === null) return;
    window.clearTimeout(noteTimer);
    noteTimer = null;
    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: field.value }),
      keepalive: true
    }).catch(function () {});
  }

  dialog.addEventListener('input', function (event) {
    if (!(event.target instanceof HTMLTextAreaElement) || !event.target.hasAttribute('data-ad-note')) return;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(flushNote, 600);
  });

  dialog.addEventListener('submit', function () {
    flushNote();
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add\/?$/.test(action)) return;
    event.preventDefault();
    var button = event.submitter || form.querySelector('[type="submit"]');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }
    var data = null;
    try {
      data = await post(action.replace(/\/$/, '') + '.js', new FormData(form));
    } catch (error) {
      if (error.name === 'AbortError') return;
      if (error.network) {
        form.submit();
      } else if (error.cart) {
        open(button);
        announce(error.message);
      } else {
        window.location.href = cartUrl;
      }
      return;
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
    render(data.sections);
    open(button);
    announce('Added to cart.');
  });

  window.addEventListener('pageshow', async function (event) {
    if (!event.persisted) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('sections', DRAWER_SECTION);
      var response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
      if (response.ok) render(await response.json());
    } catch (error) {}
  });

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target.closest('[data-ad-cart-open]') : null;
    if (!target || window.location.pathname === cartUrl) return;
    event.preventDefault();
    open();
  });
}

function setupMobileBar() {
  var bar = document.querySelector('[data-ad-mobile-bar]');
  var buy = document.querySelector('.ad-hero__buy');
  if (!bar || !buy) return;
  var drawerOpen = false;
  var frame = 0;

  function sync() {
    frame = 0;
    var show = buy.getBoundingClientRect().bottom < 0 && !drawerOpen;
    bar.classList.toggle('is-visible', show);
    bar.inert = !show;
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  document.addEventListener('ad:drawer', function (event) {
    drawerOpen = event.detail.open;
    sync();
  });
  sync();
}

function setupNav() {
  var path = location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.ad-nav a, .ad-menu__panel a').forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    var linkPath;
    try {
      linkPath = new URL(href, location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return;
    }
    if (linkPath === path) link.setAttribute('aria-current', 'page');
  });
}

function setupMenu() {
  document.querySelectorAll('[data-ad-menu]').forEach(function (menu) {
    menu.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !menu.open) return;
      menu.open = false;
      var summary = menu.querySelector('summary');
      if (summary) summary.focus();
    });
    document.addEventListener('click', function (event) {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  });
}

function setupSelects() {
  document.querySelectorAll('[data-ad-select]').forEach(function (root) {
    if (root.getAttribute('data-ad-select-ready') === 'true') return;
    var select = root.querySelector('select');
    var button = root.querySelector('.ad-select__button');
    var value = root.querySelector('.ad-select__value');
    var menu = root.querySelector('.ad-select__menu');
    if (!select || !button || !value || !menu) return;
    root.setAttribute('data-ad-select-ready', 'true');

    function paint() {
      menu.replaceChildren();
      Array.prototype.forEach.call(select.options, function (option, index) {
        var item = document.createElement('li');
        item.setAttribute('role', 'option');
        item.className = 'ad-select__option';
        item.tabIndex = -1;
        item.textContent = option.text;
        item.setAttribute('data-index', String(index));
        item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
        menu.appendChild(item);
      });
      var current = select.options[select.selectedIndex];
      value.textContent = current ? current.text : '';
    }

    function selectedItem() {
      return menu.querySelector('[aria-selected="true"]') || menu.querySelector('[role="option"]');
    }

    function open() {
      root.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      var item = selectedItem();
      if (item) item.focus();
    }

    function close(focusButton) {
      root.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      if (focusButton) button.focus();
    }

    function choose(index) {
      select.selectedIndex = index;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      paint();
      close(true);
    }

    function move(step) {
      var next = select.selectedIndex + step;
      if (next < 0) next = 0;
      if (next > select.options.length - 1) next = select.options.length - 1;
      select.selectedIndex = next;
      paint();
      var item = selectedItem();
      if (item) item.focus();
    }

    paint();
    root.classList.add('is-ready');

    button.addEventListener('click', function () {
      if (root.classList.contains('is-open')) close(false);
      else open();
    });

    menu.addEventListener('click', function (event) {
      var item = event.target.closest('[data-index]');
      if (!item || !menu.contains(item)) return;
      choose(Number(item.getAttribute('data-index')));
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (!root.classList.contains('is-open')) return;
        event.preventDefault();
        close(true);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!root.classList.contains('is-open')) open();
        else move(1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (!root.classList.contains('is-open')) open();
        else move(-1);
      } else if ((event.key === 'Enter' || event.key === ' ') && event.target !== button && root.classList.contains('is-open')) {
        var item = event.target.closest('[data-index]');
        if (!item || !menu.contains(item)) return;
        event.preventDefault();
        choose(Number(item.getAttribute('data-index')));
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close(false);
    });

    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) close(false);
    });
  });
}

function setupFilm() {
  document.querySelectorAll('[data-ad-film]').forEach(function (root) {
    if (root.hasAttribute('data-ad-film-ready')) return;
    root.setAttribute('data-ad-film-ready', '');
    var slides = root.querySelectorAll('[data-ad-slide]');
    var dots = root.querySelectorAll('[data-ad-dot]');
    var pause = root.querySelector('[data-ad-pause]');
    if (slides.length < 2) return;
    var current = 0;
    var timer = null;
    var held = false;
    var visible = false;
    var stopped = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === current;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
    }

    function schedule() {
      clearInterval(timer);
      timer = null;
      if (stopped || held || !visible || document.hidden) return;
      timer = setInterval(function () { show(current + 1); }, 6000);
    }

    function syncPause() {
      if (!pause) return;
      pause.setAttribute('aria-pressed', stopped ? 'true' : 'false');
      pause.setAttribute('aria-label', stopped ? 'Play slideshow' : 'Pause slideshow');
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(Number(dot.getAttribute('data-ad-dot')));
        schedule();
      });
    });

    if (pause) {
      pause.addEventListener('click', function () {
        stopped = !stopped;
        syncPause();
        schedule();
      });
    }

    root.addEventListener('mouseenter', function () { held = true; schedule(); });
    root.addEventListener('mouseleave', function () { held = false; schedule(); });
    root.addEventListener('focusin', function () { held = true; schedule(); });
    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      held = false;
      schedule();
    });
    document.addEventListener('visibilitychange', schedule);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries.some(function (entry) { return entry.isIntersecting; });
        schedule();
      }, { threshold: 0.3 }).observe(root);
    } else {
      visible = true;
    }

    syncPause();
    schedule();
  });
}

function dressCookieBanner() {
  var banner = document.getElementById('shopify-pc__banner');
  if (!banner || banner.querySelector('.ad-cookie-mark')) return;
  var src = document.body.getAttribute('data-cookie-mark');
  if (!src) return;
  var mark = document.createElement('span');
  mark.className = 'ad-cookie-mark';
  var img = document.createElement('img');
  img.alt = '';
  img.src = src;
  mark.appendChild(img);
  var wrap = banner.querySelector('.shopify-pc__banner__wrapper') || banner;
  wrap.insertBefore(mark, wrap.firstChild);
}

function setupClips() {
  var root = document.querySelector('[data-ad-clips]');
  if (!root || root.getAttribute('data-ad-clips-ready') === 'true') return;
  var dialog = root.querySelector('[data-ad-clips-dialog]');
  var openBtn = root.querySelector('[data-ad-clips-open]');
  var preview = root.querySelector('[data-ad-clips-preview]');
  if (!dialog || !openBtn) return;
  root.setAttribute('data-ad-clips-ready', 'true');

  var slides = Array.prototype.slice.call(dialog.querySelectorAll('[data-ad-clips-slide]'));
  var frameEl = dialog.querySelector('[data-ad-clips-frame]');
  var scroller = dialog.querySelector('[data-ad-clips-scroller]');
  var bank = root.querySelector('[data-ad-clips-bank]');
  var index = -1;
  var settle = 0;
  var cardTimer = 0;
  var locking = false;
  var patternAt = 0;
  var videoAt = 0;
  var quoteAt = 0;
  var quizAt = 0;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mix = ['offer', 'video', 'quote', 'video', 'quiz', 'video', 'quote', 'video'];
  var quotes = [];
  var quoteNode = root.querySelector('[data-ad-clips-quotes]');
  if (quoteNode) {
    try { quotes = JSON.parse(quoteNode.textContent); } catch (error) { quotes = []; }
  }

  if (reduced && preview) {
    preview.removeAttribute('autoplay');
    preview.pause();
  }

  function playVideo(video) {
    video.pause();
    try { video.currentTime = 0; } catch (error) {}
    video.muted = false;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        video.muted = true;
        video.play();
      });
    }
  }

  function clearCardTimer() {
    window.clearTimeout(cardTimer);
  }

  function templateNode(name) {
    var tpl = bank && bank.querySelector('[data-ad-clip-template="' + name + '"]');
    if (!tpl || !tpl.content) return null;
    var fragment = tpl.content.cloneNode(true);
    return fragment.querySelector('[data-ad-clips-slide]') || fragment.firstElementChild;
  }

  function nextPiece() {
    var kind = mix[patternAt % mix.length];
    patternAt += 1;
    if (kind === 'video') {
      var videoNode = videoTemplates[videoAt % videoTemplates.length].cloneNode(true);
      videoAt += 1;
      return videoNode;
    }
    if (kind === 'quote') {
      var quoteSlide = templateNode('quote');
      var line = quoteSlide && quoteSlide.querySelector('[data-ad-quote]');
      if (line && quotes.length) {
        line.textContent = quotes[quoteAt % quotes.length];
        quoteAt += 1;
      }
      return quoteSlide;
    }
    if (kind === 'quiz') {
      var quizName = quizAt % 2 === 0 ? 'quiz' : 'quiz-b';
      quizAt += 1;
      return templateNode(quizName);
    }
    return templateNode('offer');
  }

  function appendOne() {
    var node = nextPiece();
    if (!node || !scroller) return;
    scroller.appendChild(node);
    slides.push(node);
  }

  function ensureAhead() {
    var ahead = Math.max(index, 0) + 4;
    while (slides.length < ahead) appendOne();
  }

  function trimBehind() {
    var height = scroller ? scroller.clientHeight : 0;
    if (!height || locking || index < 6 || slides.length < 13) return;
    var gone = slides.shift();
    if (!gone) return;
    var oldVideo = gone.querySelector('video');
    if (oldVideo) oldVideo.pause();
    gone.remove();
    index -= 1;
    locking = true;
    scroller.style.scrollSnapType = 'none';
    scroller.scrollTop = Math.max(0, scroller.scrollTop - height);
    scroller.style.scrollSnapType = '';
    window.setTimeout(function () { locking = false; }, 80);
  }

  function armCard(slide) {
    clearCardTimer();
    if (!slide || !slide.hasAttribute('data-ad-card') || !dialog.open) return;
    var wait = parseInt(slide.getAttribute('data-ad-card-ms') || '5600', 10);
    slide.style.setProperty('--ad-card-ms', (wait / 1000) + 's');
    cardTimer = window.setTimeout(function () {
      if (!dialog.open || slides[index] !== slide) return;
      goToSlide(index + 1);
    }, wait);
  }

  function syncSlides(force) {
    if (!scroller || locking) return;
    var height = scroller.clientHeight || 1;
    var next = Math.round(scroller.scrollTop / height);
    next = Math.max(0, Math.min(slides.length - 1, next));
    if (!force && next === index) return;
    index = next;
    slides.forEach(function (slide, item) {
      var video = slide.querySelector('video');
      var active = item === index;
      slide.classList.toggle('is-active', active);
      if (!video) return;
      if (active) {
        slide.classList.remove('is-paused');
        playVideo(video);
      } else {
        video.pause();
      }
    });
    ensureAhead();
    armCard(slides[index]);
  }

  function goToSlide(next) {
    if (!scroller || next < 0) return;
    clearCardTimer();
    while (slides.length <= next) appendOne();
    var height = scroller.clientHeight || 0;
    scroller.scrollTo({ top: next * height, behavior: reduced ? 'auto' : 'smooth' });
  }

  function answerQuiz(choice) {
    var quiz = choice.closest('[data-ad-quiz]');
    var slide = choice.closest('[data-ad-clips-slide]');
    if (!quiz || !slide || quiz.hasAttribute('data-ad-answered')) return;
    quiz.setAttribute('data-ad-answered', 'true');
    var answer = quiz.getAttribute('data-ad-answer');
    var picked = choice.getAttribute('data-ad-choice');
    quiz.querySelectorAll('[data-ad-choice]').forEach(function (button) {
      button.disabled = true;
      if (button.getAttribute('data-ad-choice') === answer) button.classList.add('is-right');
      else if (button === choice) button.classList.add('is-wrong');
    });
    var note = quiz.querySelector('[data-ad-quiz-note]');
    if (note) {
      note.hidden = false;
      note.textContent = picked === answer ? quiz.getAttribute('data-ad-right') : quiz.getAttribute('data-ad-wrong');
    }
    var nextLink = quiz.querySelector('[data-ad-quiz-next]');
    if (nextLink) nextLink.hidden = false;
    slide.removeAttribute('data-ad-hold');
    slide.setAttribute('data-ad-card-ms', '3200');
    slide.classList.remove('is-active');
    void slide.offsetWidth;
    slide.classList.add('is-active');
    armCard(slide);
  }

  function resetFeed() {
    clearCardTimer();
    patternAt = 0;
    videoAt = 1;
    quoteAt = 0;
    quizAt = 0;
    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (video) video.pause();
      slide.remove();
    });
    slides = [];
    var first = videoTemplates[0].cloneNode(true);
    scroller.appendChild(first);
    slides.push(first);
    while (slides.length < 6) appendOne();
    index = -1;
  }

  function togglePlayback(slide) {
    var video = slide.querySelector('video');
    if (!video || slides.indexOf(slide) !== index) return;
    if (video.paused || video.ended) {
      video.muted = false;
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          video.muted = true;
          video.play();
        });
      }
      slide.classList.remove('is-paused');
      return;
    }
    video.pause();
    slide.classList.add('is-paused');
  }

  var motion = 0;

  function expandFromFab(slide) {
    if (reduced) return;
    var token = ++motion;
    var from = openBtn.getBoundingClientRect();
    var to = slide.getBoundingClientRect();
    if (!from.width || !to.width) return;
    var scale = from.width / to.width;
    var dx = (from.left + from.width / 2) - (to.left + to.width / 2);
    var dy = (from.top + from.height / 2) - (to.top + to.height / 2);
    var settled = false;
    slide.style.transition = 'none';
    slide.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ')';
    void slide.offsetWidth;
    slide.style.transition = 'transform 320ms ease';
    slide.style.transform = 'translate(0px, 0px) scale(1)';
    function done(event) {
      if (token !== motion || settled) return;
      if (event && event.propertyName && event.propertyName !== 'transform') return;
      settled = true;
      slide.style.transition = '';
      slide.style.transform = '';
      slide.removeEventListener('transitionend', done);
    }
    slide.addEventListener('transitionend', done);
    window.setTimeout(function () { done({ propertyName: 'transform' }); }, 400);
  }

  function collapseToFab(done) {
    if (reduced || !frameEl) {
      done();
      return;
    }
    var token = ++motion;
    var from = frameEl.getBoundingClientRect();
    var to = openBtn.getBoundingClientRect();
    if (!from.width || !to.width) {
      done();
      return;
    }
    var scale = to.width / from.width;
    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + to.height / 2);
    var settled = false;
    function finish(event) {
      if (token !== motion) return;
      if (event && event.propertyName && event.propertyName !== 'transform') return;
      if (settled) return;
      settled = true;
      frameEl.removeEventListener('transitionend', finish);
      done();
      frameEl.style.transition = '';
      frameEl.style.transform = '';
    }
    frameEl.style.transition = 'none';
    frameEl.style.transform = 'translate(0px, 0px) scale(1)';
    void frameEl.offsetWidth;
    frameEl.style.transition = 'transform 320ms ease';
    void frameEl.offsetWidth;
    frameEl.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ')';
    frameEl.addEventListener('transitionend', finish);
    window.setTimeout(function () { finish(); }, 420);
  }

  function openClips() {
    if (preview) preview.pause();
    document.body.classList.add('ad-clips-open');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    resetFeed();
    if (scroller) scroller.scrollTop = 0;
    syncSlides(true);
    if (frameEl) expandFromFab(frameEl);
    var closeBtn = dialog.querySelector('[data-ad-clips-close]');
    if (closeBtn) closeBtn.focus();
  }

  function formatCount(value) {
    if (value >= 10000) {
      var whole = value / 1000;
      return (Math.round(whole * 10) / 10).toString().replace(/\.0$/, '') + 'K';
    }
    if (value >= 1000) {
      var short = Math.round(value / 100) / 10;
      return short.toFixed(short % 1 ? 1 : 0) + 'K';
    }
    return String(value);
  }

  function toggleCount(button) {
    var pressed = button.getAttribute('aria-pressed') === 'true';
    var count = parseInt(button.getAttribute('data-count') || '0', 10);
    var next = pressed ? Math.max(0, count - 1) : count + 1;
    if (count >= 1000 && formatCount(next) === formatCount(count)) {
      next = pressed ? Math.max(0, count - 100) : count + 100;
    }
    button.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    button.setAttribute('data-count', String(next));
    var label = button.querySelector('[data-ad-clips-count]');
    if (label) label.textContent = formatCount(next);
  }

  function closeSheets() {
    dialog.querySelectorAll('.ad-clips__sheet').forEach(function (sheet) {
      sheet.hidden = true;
    });
    dialog.querySelectorAll('[data-ad-clips-comments]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
    dialog.querySelectorAll('[data-ad-clips-copy-label]').forEach(function (label) {
      label.textContent = 'Copy link';
    });
  }

  function copyLink(button) {
    var url = window.location.href;
    var label = button.querySelector('[data-ad-clips-copy-label]');
    function done() {
      if (label) label.textContent = 'Copied';
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {
        writeLink(url);
        done();
      });
      return;
    }
    writeLink(url);
    done();
  }

  function writeLink(url) {
    var field = document.createElement('textarea');
    field.value = url;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.insetInlineStart = '-999px';
    document.body.appendChild(field);
    field.select();
    try { document.execCommand('copy'); } catch (error) {}
    field.remove();
  }

  var closing = false;

  function finishClose() {
    closing = false;
    clearCardTimer();
    document.body.classList.remove('ad-clips-open');
    closeSheets();
    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (video) {
        video.pause();
        video.muted = true;
      }
    });
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    if (preview && !reduced) {
      var attempt = preview.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    }
    openBtn.focus();
  }

  function closeClips() {
    if (closing) return;
    if (!dialog.open && !dialog.hasAttribute('open')) return;
    closing = true;
    clearCardTimer();
    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (video) video.pause();
    });
    collapseToFab(finishClose);
  }

  openBtn.addEventListener('click', openClips);
  dialog.querySelector('[data-ad-clips-close]').addEventListener('click', closeClips);
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeClips();
  });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) {
      closeClips();
      return;
    }
    var like = event.target.closest('[data-ad-clips-like]');
    if (like) {
      toggleCount(like);
      return;
    }
    var save = event.target.closest('[data-ad-clips-save]');
    if (save) {
      toggleCount(save);
      return;
    }
    var comments = event.target.closest('[data-ad-clips-comments]');
    if (comments) {
      var commentSlide = comments.closest('[data-ad-clips-slide]');
      var sheet = commentSlide && commentSlide.querySelector('.ad-clips__sheet');
      var willOpen = sheet && sheet.hidden;
      closeSheets();
      if (willOpen && sheet) {
        sheet.hidden = false;
        comments.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (event.target.closest('[data-ad-clips-sheet-close]')) {
      closeSheets();
      return;
    }
    var more = event.target.closest('[data-ad-clips-more]');
    if (more) {
      var blurb = more.closest('.ad-clips__blurb');
      var shortText = blurb && blurb.querySelector('[data-ad-clips-short]');
      var longText = blurb && blurb.querySelector('[data-ad-clips-long]');
      var expanded = more.getAttribute('aria-expanded') === 'true';
      more.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      more.textContent = expanded ? 'more' : 'less';
      if (shortText) shortText.hidden = !expanded;
      if (longText) longText.hidden = expanded;
      return;
    }
    var share = event.target.closest('[data-ad-clips-share]');
    if (share) {
      var shareSlide = share.closest('[data-ad-clips-slide]');
      var shareSheet = shareSlide && shareSlide.querySelector('[data-ad-clips-share-sheet]');
      var shareWillOpen = shareSheet && shareSheet.hidden;
      closeSheets();
      if (shareWillOpen && shareSheet) shareSheet.hidden = false;
      return;
    }
    var copy = event.target.closest('[data-ad-clips-copy]');
    if (copy) {
      copyLink(copy);
      return;
    }
    var nativeShare = event.target.closest('[data-ad-clips-native-share]');
    if (nativeShare) {
      var nativeSlide = nativeShare.closest('[data-ad-clips-slide]');
      var title = nativeSlide && nativeSlide.querySelector('h2');
      var text = title ? title.textContent.trim() : 'ANTIDUMB';
      if (navigator.share) {
        navigator.share({ title: text, text: text, url: window.location.href }).catch(function () {});
      } else {
        var copyButton = nativeSlide && nativeSlide.querySelector('[data-ad-clips-copy]');
        if (copyButton) copyLink(copyButton);
      }
      return;
    }
    var choice = event.target.closest('[data-ad-choice]');
    if (choice) {
      answerQuiz(choice);
      return;
    }
    var leave = event.target.closest('[data-ad-clips-buy], [data-ad-quiz-next]');
    if (leave) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      var href = leave.getAttribute('href');
      closeClips();
      if (href) window.location.href = href;
      return;
    }
    var slideHit = event.target.closest('[data-ad-clips-slide]');
    if (slideHit && !event.target.closest('.ad-clips__rail, .ad-clips__caption, .ad-clips__sheet, .ad-clips__close')) {
      if (slideHit.querySelector('.ad-clips__sheet:not([hidden])')) {
        closeSheets();
        return;
      }
      togglePlayback(slideHit);
    }
  });
  if (!navigator.share) {
    dialog.querySelectorAll('[data-ad-clips-native-share]').forEach(function (button) {
      button.hidden = true;
    });
  }
  var videoTemplates = slides.map(function (slide) {
    return slide.cloneNode(true);
  });
  dialog.addEventListener('wheel', function (event) {
    if (event.target.closest('.ad-clips__sheet ul')) event.stopPropagation();
  }, { passive: true });
  dialog.addEventListener('touchmove', function (event) {
    if (event.target.closest('.ad-clips__sheet ul')) event.stopPropagation();
  }, { passive: true });
  dialog.addEventListener('ended', function (event) {
    var video = event.target;
    if (!video || video.tagName !== 'VIDEO') return;
    var slide = video.closest('[data-ad-clips-slide]');
    if (!slide || slides.indexOf(slide) !== index || !dialog.open) return;
    goToSlide(index + 1);
  }, true);
  if (scroller) {
    scroller.addEventListener('scroll', function () {
      if (locking) return;
      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        if (locking) return;
        syncSlides(false);
        trimBehind();
      }, 90);
    }, { passive: true });
    scroller.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        goToSlide(index + 1);
      }
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        goToSlide(Math.max(index - 1, 0));
      }
    });
  }
}

function setupCursorClip() {
  var area = document.querySelector('[data-ad-cursor-clip-area]');
  if (!area || area.getAttribute('data-ad-cursor-clip-ready') === 'true') return;
  var bubble = area.querySelector('[data-ad-cursor-clip]');
  var dialog = area.querySelector('[data-ad-cursor-clip-dialog]');
  var frame = dialog && dialog.querySelector('[data-ad-cursor-clip-frame]');
  var player = dialog && dialog.querySelector('[data-ad-cursor-clip-player]');
  var slide = dialog && dialog.querySelector('[data-ad-cursor-clip-slide]');
  var stage = dialog && dialog.querySelector('.ad-clips__stage');
  var closeBtn = dialog && dialog.querySelector('[data-ad-cursor-clip-close]');
  var preview = area.querySelector('[data-ad-cursor-clip-preview]');
  if (!bubble || !dialog || !frame || !player || typeof dialog.showModal !== 'function') return;
  area.setAttribute('data-ad-cursor-clip-ready', 'true');

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var size = 100;
  var target = { x: 0, y: 0 };
  var pos = { x: 0, y: 0 };
  var last = { x: 0, y: 0 };
  var origin = { x: 0, y: 0 };
  var frameId = 0;
  var inside = false;
  var closing = false;
  var motion = 0;

  function clipSize() {
    return bubble.offsetWidth || size;
  }

  function place() {
    var clip = clipSize();
    bubble.style.transform = 'translate3d(' + (pos.x - clip / 2) + 'px, ' + (pos.y - clip / 2) + 'px, 0)';
  }

  function step() {
    frameId = 0;
    var dx = target.x - pos.x;
    var dy = target.y - pos.y;
    if (reduced.matches || Math.abs(dx) + Math.abs(dy) < 0.5) {
      pos.x = target.x;
      pos.y = target.y;
    } else {
      pos.x += dx * 0.24;
      pos.y += dy * 0.24;
      frameId = requestAnimationFrame(step);
    }
    place();
  }

  function follow(x, y, jump) {
    target.x = x;
    target.y = y;
    if (jump) {
      pos.x = x;
      pos.y = y;
    }
    if (!frameId) frameId = requestAnimationFrame(step);
  }

  function playMedia(video, sound) {
    if (!video) return;
    video.preload = 'auto';
    video.muted = !sound;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        if (!sound) return;
        video.muted = true;
        video.play().catch(function () {});
      });
    }
  }

  function show(on) {
    bubble.classList.toggle('is-on', on);
    area.classList.toggle('is-cursor-clip', on);
    if (on && !reduced.matches) playMedia(preview, false);
    else if (preview) preview.pause();
  }

  function overControl(node) {
    return node && node.closest && node.closest('a, button:not([data-ad-cursor-clip]), summary, input, select, textarea, label');
  }

  function bubbleCenter() {
    var rect = bubble.getBoundingClientRect();
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
  }

  var inView = false;

  function syncStatic() {
    if (fine.matches || dialog.open || reduced.matches) return;
    if (inView) playMedia(preview, false);
    else if (preview) preview.pause();
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      inView = entries.some(function (entry) { return entry.isIntersecting; });
      syncStatic();
    }).observe(bubble);
  }

  function within(point) {
    var rect = area.getBoundingClientRect();
    return point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom;
  }

  function restClip() {
    var radius = stage ? getComputedStyle(stage).borderTopLeftRadius : '0px';
    return 'inset(0px 0px round ' + radius + ')';
  }

  function bubbleShape(rect, point) {
    var top = (rect.height - rect.width) / 2;
    var dx = point.x - (rect.left + rect.width / 2);
    var dy = point.y - (rect.top + rect.height / 2);
    return {
      transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + ((bubble.offsetWidth || size) / rect.width) + ')',
      clip: 'inset(' + top + 'px 0px round ' + (rect.width / 2) + 'px)'
    };
  }

  function clearFrame() {
    frame.style.transition = '';
    frame.style.transform = '';
    frame.style.clipPath = '';
  }

  function morph(from, to, done) {
    var token = ++motion;
    var settled = false;
    frame.style.transition = 'none';
    frame.style.transform = from.transform;
    frame.style.clipPath = from.clip;
    void frame.offsetWidth;
    frame.style.transition = 'transform 320ms ease, clip-path 320ms ease';
    frame.style.transform = to.transform;
    frame.style.clipPath = to.clip;
    function finish(event) {
      if (token !== motion || settled) return;
      if (event && (event.target !== frame || event.propertyName !== 'transform')) return;
      settled = true;
      frame.removeEventListener('transitionend', finish);
      done();
    }
    frame.addEventListener('transitionend', finish);
    window.setTimeout(function () { finish(); }, 420);
  }

  function open() {
    if (dialog.open || closing) return;
    origin = fine.matches ? { x: pos.x, y: pos.y } : bubbleCenter();
    bubble.classList.add('is-hidden');
    try { player.currentTime = 0; } catch (error) {}
    if (preview) preview.pause();
    dialog.classList.add('is-entering');
    dialog.showModal();
    document.body.classList.add('ad-cursor-clip-open');
    slide.classList.remove('is-paused');
    playMedia(player, true);
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    requestAnimationFrame(function () { dialog.classList.remove('is-entering'); });
    if (reduced.matches) return;
    morph(bubbleShape(frame.getBoundingClientRect(), origin), { transform: 'translate(0px, 0px) scale(1)', clip: restClip() }, clearFrame);
  }

  function finishClose() {
    closing = false;
    player.pause();
    dialog.close();
    dialog.classList.remove('is-closing');
    document.body.classList.remove('ad-cursor-clip-open');
    clearFrame();
    inside = fine.matches && within(last);
    if (inside) follow(last.x, last.y, true);
    else follow(origin.x, origin.y, true);
    bubble.classList.remove('is-hidden');
    show(inside);
    syncStatic();
  }

  function close() {
    if (!dialog.open || closing) return;
    closing = true;
    player.pause();
    dialog.classList.add('is-closing');
    if (reduced.matches) {
      finishClose();
      return;
    }
    var point = fine.matches ? (within(last) ? last : origin) : bubbleCenter();
    morph({ transform: 'translate(0px, 0px) scale(1)', clip: restClip() }, bubbleShape(frame.getBoundingClientRect(), point), finishClose);
  }

  area.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse' || !fine.matches || dialog.open) return;
    last = { x: event.clientX, y: event.clientY };
    follow(event.clientX, event.clientY, !inside);
    inside = true;
    show(!overControl(event.target));
  });

  area.addEventListener('pointerleave', function (event) {
    if (event.pointerType !== 'mouse' || dialog.open) return;
    inside = false;
    if (document.activeElement !== bubble) show(false);
  });

  dialog.addEventListener('pointermove', function (event) {
    last = { x: event.clientX, y: event.clientY };
  });

  area.addEventListener('click', function (event) {
    if (dialog.contains(event.target) || bubble.contains(event.target)) return;
    if (!fine.matches || overControl(event.target)) return;
    var selection = window.getSelection && window.getSelection();
    if (selection && !selection.isCollapsed) return;
    follow(event.clientX, event.clientY, true);
    open();
  });

  bubble.addEventListener('click', open);

  bubble.addEventListener('focus', function () {
    if (!bubble.matches(':focus-visible')) return;
    var rect = area.getBoundingClientRect();
    var rtl = getComputedStyle(area).direction === 'rtl';
    var clip = clipSize();
    var x = rtl ? Math.max(rect.left, 0) + 32 + clip / 2 : Math.min(rect.right, window.innerWidth) - 32 - clip / 2;
    var y = Math.max(rect.top, 0) + 32 + clip / 2;
    follow(x, y, true);
    if (!reduced.matches) playMedia(preview, false);
  });

  bubble.addEventListener('blur', function () {
    if (!inside && !dialog.open && fine.matches) show(false);
  });

  if (closeBtn) closeBtn.addEventListener('click', close);

  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    close();
  });

  dialog.addEventListener('click', close);
}

var adReviewCancels = [];
var adReviewMediaBound = false;

function setupReviews() {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!adReviewMediaBound) {
    adReviewMediaBound = true;
    reduced.addEventListener('change', function () {
      if (!reduced.matches) return;
      adReviewCancels.forEach(function (cancel) { cancel(); });
      document.querySelectorAll('.ad-reviews__marquee').forEach(function (node) {
        node.classList.remove('is-held', 'is-dragging');
        var view = node.querySelector('.ad-reviews__viewport');
        if (!view) return;
        view.style.removeProperty('transform');
        view.style.removeProperty('animation-delay');
        view.style.removeProperty('animation-name');
      });
    });
  }

  document.querySelectorAll('.ad-reviews__marquee').forEach(function (marquee) {
    if (marquee.getAttribute('data-ad-reviews') === 'ready') return;
    var viewport = marquee.querySelector('.ad-reviews__viewport');
    if (!viewport) return;
    marquee.setAttribute('data-ad-reviews', 'ready');

    var loop = 0;
    var reversePlayback = false;
    var resumeTimer = 0;
    var coastFrame = 0;
    var gesture = 0;
    var pointer = null;

    function measure() {
      loop = viewport.getBoundingClientRect().width / 2;
    }

    function durationMs() {
      var raw = window.getComputedStyle(viewport).getPropertyValue('--ad-reviews-duration').trim();
      var value = parseFloat(raw);
      if (!value) return 90000;
      return raw.slice(-2) === 'ms' ? value : value * 1000;
    }

    function readX() {
      var transform = window.getComputedStyle(viewport).transform;
      if (!transform || transform === 'none') return 0;
      if (window.DOMMatrix) {
        try { return new DOMMatrix(transform).m41; } catch (error) {}
      }
      var parts = transform.match(/-?\d+\.?\d*(?:e-?\d+)?/gi);
      if (!parts || parts.length < 6) return 0;
      return parseFloat(parts.length > 6 ? parts[12] : parts[4]) || 0;
    }

    function wrap(x) {
      if (!loop) return x;
      var mod = x % loop;
      if (mod > 0 && mod < 1) return 0;
      if (mod > 0) mod -= loop;
      return mod;
    }

    function setX(x) {
      var next = Math.round(wrap(x));
      viewport.style.transform = 'translate3d(' + next + 'px, 0, 0)';
      return next;
    }

    function stopFollow() {
      gesture += 1;
      window.clearTimeout(resumeTimer);
      window.cancelAnimationFrame(coastFrame);
    }

    function hold() {
      if (marquee.classList.contains('is-held')) return true;
      measure();
      if (!loop) return false;
      reversePlayback = window.getComputedStyle(viewport).animationDirection === 'reverse';
      var x = Math.round(wrap(readX()));
      viewport.style.animationName = 'none';
      viewport.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      marquee.classList.add('is-held');
      return true;
    }

    function resumeAuto() {
      if (!marquee.isConnected || !marquee.classList.contains('is-held')) return;
      measure();
      var wrapped = wrap(readX());
      var progress = loop ? -wrapped / loop : 0;
      if (progress < 0) progress = 0;
      if (progress >= 0.999) progress = 0;
      var portion = reversePlayback ? 1 - progress : progress;
      if (portion < 0) portion = 0;
      if (portion >= 0.999) portion = 0;
      viewport.style.animationDelay = (-portion * durationMs()) + 'ms';
      viewport.style.removeProperty('animation-name');
      viewport.style.removeProperty('transform');
      marquee.classList.remove('is-held');
    }

    function scheduleResume() {
      window.clearTimeout(resumeTimer);
      var token = gesture;
      resumeTimer = window.setTimeout(function () {
        if (token !== gesture) return;
        resumeAuto();
      }, 520);
    }

    function coast(speed) {
      var capped = Math.max(-2, Math.min(2, speed));
      if (Math.abs(capped) < 0.12 || !loop) {
        scheduleResume();
        return;
      }
      var token = gesture;
      var from = readX();
      var travel = capped * 170;
      var start = window.performance.now();
      function frame(now) {
        if (token !== gesture) return;
        var t = Math.min(1, (now - start) / 280);
        var eased = 1 - Math.pow(1 - t, 3);
        setX(from + travel * eased);
        if (t < 1) coastFrame = window.requestAnimationFrame(frame);
        else scheduleResume();
      }
      coastFrame = window.requestAnimationFrame(frame);
    }

    function detach() {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      pointer = null;
      marquee.classList.remove('is-dragging');
    }

    function onMove(event) {
      if (!pointer || event.pointerId !== pointer.id) return;
      if (reduced.matches || !marquee.isConnected) {
        detach();
        return;
      }
      var dx = event.clientX - pointer.x;
      var dy = event.clientY - pointer.y;
      if (!pointer.axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        pointer.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (pointer.axis === 'y') return;
        if (!hold()) {
          pointer.axis = 'y';
          return;
        }
        pointer.origin = readX();
        marquee.classList.add('is-dragging');
        if (window.getSelection) {
          var selection = window.getSelection();
          if (selection && selection.removeAllRanges) selection.removeAllRanges();
        }
      }
      if (pointer.axis !== 'x') return;
      if (event.cancelable) event.preventDefault();
      pointer.samples.push({ x: event.clientX, time: event.timeStamp });
      var cutoff = event.timeStamp - 90;
      while (pointer.samples.length > 2 && pointer.samples[0].time < cutoff) pointer.samples.shift();
      setX(pointer.origin + dx);
    }

    function onUp(event) {
      if (!pointer || event.pointerId !== pointer.id) return;
      var dragged = pointer.axis === 'x';
      var speed = 0;
      if (dragged && pointer.samples.length >= 2) {
        var first = pointer.samples[0];
        var last = pointer.samples[pointer.samples.length - 1];
        var dt = last.time - first.time;
        if (dt > 0) speed = (last.x - first.x) / dt;
      }
      detach();
      if (!dragged) {
        if (marquee.classList.contains('is-held')) scheduleResume();
        return;
      }
      coast(speed);
    }

    function onDown(event) {
      if (reduced.matches || pointer) return;
      if (event.isPrimary === false) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      stopFollow();
      pointer = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        origin: 0,
        axis: '',
        samples: [{ x: event.clientX, time: event.timeStamp }]
      };
      window.addEventListener('pointermove', onMove, { passive: false });
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    }

    marquee.addEventListener('pointerdown', onDown);
    adReviewCancels.push(function () {
      detach();
      stopFollow();
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setupClips();
  setupCursorClip();
  document.addEventListener('shopify:section:load', setupCursorClip);
  setupSwitcher();
  setupDrawer();
  setupMobileBar();
  setupNav();
  setupMenu();
  setupSelects();
  setupFilm();
  document.addEventListener('shopify:section:load', setupFilm);
  setupReviews();
  document.addEventListener('shopify:section:load', setupReviews);
  dressCookieBanner();
  new MutationObserver(dressCookieBanner).observe(document.documentElement, { childList: true, subtree: true });

  document.querySelectorAll('[data-ad-buy]').forEach(function (box) {
    var idInput = box.querySelector('[data-ad-id]');
    var label = box.querySelector('[data-ad-label]');
    var choices = box.querySelectorAll('[data-ad-variant]');

    function selected() {
      var current = box.querySelector('[data-ad-variant].is-selected, [data-ad-variant]:checked');
      if (!current) current = choices[0];
      return current;
    }

    function sync() {
      var current = selected();
      if (!current) return;
      var id = current.getAttribute('data-id') || current.value;
      var price = current.getAttribute('data-price') || '';
      if (idInput && id) idInput.value = id;
      if (label) label.textContent = 'Add to cart - ' + price;
      choices.forEach(function (choice) {
        if (choice.tagName === 'BUTTON') {
          choice.classList.toggle('is-selected', choice === current);
          choice.setAttribute('aria-pressed', choice === current ? 'true' : 'false');
        }
      });
    }

    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        if (choice.tagName === 'BUTTON') {
          choices.forEach(function (other) {
            other.classList.remove('is-selected');
          });
          choice.classList.add('is-selected');
        }
        sync();
      });
      choice.addEventListener('change', sync);
    });

    sync();
  });

  document.querySelectorAll('[data-ad-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-ad-main]');
    gallery.querySelectorAll('[data-ad-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = thumb.getAttribute('data-src');
        main.alt = thumb.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-ad-thumb]').forEach(function (other) {
          other.classList.remove('is-selected');
          other.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-selected');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });

  document.querySelectorAll('[data-ad-odo]').forEach(function (node) {
    var value = parseInt(node.getAttribute('data-ad-odo'), 10);
    if (isNaN(value)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      node.textContent = String(value);
      return;
    }
    var digits = value === 0 ? [3, 2, 1, 0] : [];
    if (value !== 0) {
      for (var n = 0; n <= value; n += 1) digits.push(n);
    }
    var viewport = document.createElement('span');
    viewport.className = 'ad-odo__window';
    viewport.setAttribute('aria-hidden', 'true');
    var strip = document.createElement('span');
    strip.className = 'ad-odo__strip';
    digits.forEach(function (digit) {
      var line = document.createElement('span');
      line.textContent = String(digit);
      strip.appendChild(line);
    });
    viewport.appendChild(strip);
    var label = document.createElement('span');
    label.className = 'ad-visually-hidden';
    label.textContent = String(value);
    node.textContent = '';
    node.appendChild(viewport);
    node.appendChild(label);
    var played = false;
    var observer = new IntersectionObserver(function (entries) {
      if (played || !entries.some(function (entry) { return entry.isIntersecting; })) return;
      played = true;
      observer.disconnect();
      var steps = digits.length - 1;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          strip.style.transform = 'translateY(' + (-steps) + 'em)';
        });
      });
    }, { threshold: 0.6 });
    observer.observe(node);
  });

  /* Shopify spam protection binds hCaptcha on first focus, swaps form.submit for a step
     that adds the token, then calls the submit it found when it bound. */
  function adCaptchaSubmit(form, send) {
    var captcha = window.Shopify && window.Shopify.captcha;
    if (form.hasAttribute('data-hcaptcha-bound')) {
      form.submit();
    } else if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(form, function () {
        form.submit();
      });
    } else {
      send();
    }
  }

  /* Must run before hCaptcha binds, so the token step hands off to this fetch. */
  function adCustomerPoster(form) {
    var settle = null;
    function send() {
      var done = settle;
      settle = null;
      if (!done) return;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      }).then(function (response) {
        return response.text().then(function (html) {
          var url = response.url || '';
          done(url.indexOf('customer_posted=true') !== -1 || html.indexOf('customer_posted=true') !== -1);
        });
      }).catch(function () {
        done(false);
      });
    }
    form.submit = send;
    return function () {
      return new Promise(function (resolve) {
        settle = resolve;
        adCaptchaSubmit(form, send);
      });
    };
  }

  function adFieldLabel(form, field) {
    var label = field.id ? form.querySelector('label[for="' + field.id + '"], #' + field.id + '-label') : null;
    if (label) return label.textContent.trim();
    return field.name.replace(/^contact\[|\]$/g, '').replace(/_/g, ' ');
  }

  document.querySelectorAll('.ad-form').forEach(function (fields) {
    var form = fields.closest('form');
    if (!form) return;
    var customerForm = document.getElementById(form.getAttribute('data-ad-customer-form') || '');
    var postCustomer = customerForm ? adCustomerPoster(customerForm) : null;
    form.setAttribute('novalidate', 'novalidate');
    form.addEventListener('submit', function (event) {
      fields.querySelectorAll('.ad-error').forEach(function (node) {
        node.remove();
      });
      var first = null;
      fields.querySelectorAll('input, select, textarea').forEach(function (field) {
        field.removeAttribute('aria-invalid');
        var value = (field.value || '').trim();
        var message = '';
        if (field.required && !value) message = 'Enter this before sending.';
        if (!message && field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          message = 'Enter a valid email.';
        }
        if (!message) return;
        var note = document.createElement('p');
        note.className = 'ad-error';
        note.textContent = message;
        field.setAttribute('aria-invalid', 'true');
        var slot = field.closest('.ad-field');
        if (slot) slot.appendChild(note);
        if (!first) first = field;
      });
      if (first) {
        event.preventDefault();
        first.focus();
        return;
      }
      if (form.getAttribute('data-ad-mail-ready') === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      function sendMessage() {
        form.setAttribute('data-ad-mail-ready', 'true');
        adCaptchaSubmit(form, function () {
          HTMLFormElement.prototype.submit.call(form);
        });
      }

      var emailField = fields.querySelector('input[type="email"]');
      if (!postCustomer || !emailField) {
        sendMessage();
        return;
      }

      var nameField = form.querySelector('[name="contact[name]"]');
      var names = nameField ? nameField.value.trim().split(/\s+/) : [];
      var lines = [(form.id || 'contact').replace(/^./, function (c) { return c.toUpperCase(); }) + ' form, ' + new Date().toISOString().slice(0, 10)];
      fields.querySelectorAll('[name^="contact["]').forEach(function (field) {
        var value = (field.value || '').trim();
        if (!value || field === emailField) return;
        lines.push(adFieldLabel(form, field) + ': ' + value);
      });
      function setCustomer(key, value) {
        var input = customerForm.querySelector('[data-ad-customer="' + key + '"]');
        if (input) input.value = value;
      }
      setCustomer('email', emailField.value.trim());
      setCustomer('first_name', names.shift() || '');
      setCustomer('last_name', names.join(' '));
      setCustomer('note', lines.join('\n').slice(0, 4000));

      /* Saving the customer must never block the message to the shop. */
      var sent = false;
      var wait = window.setTimeout(next, 20000);
      function next() {
        if (sent) return;
        sent = true;
        window.clearTimeout(wait);
        sendMessage();
      }
      postCustomer().then(next);
    });
  });
});
